import axios from 'axios';
import $ from 'jquery';
import { message } from 'antd';
import { CONFIG_LOCAL_STORAGE, PATHS } from '../constants/Define';
import Config from '../constants/Config';
import history from '../helpers/history';
import { LocalStorage } from '../utils';

const clearAuthStorage = () => {
    [
        CONFIG_LOCAL_STORAGE.AUTHENTICATING,
        CONFIG_LOCAL_STORAGE.ACCESS_TOKEN,
        CONFIG_LOCAL_STORAGE.REFRESH_TOKEN,
        CONFIG_LOCAL_STORAGE.EXPIRES,
        CONFIG_LOCAL_STORAGE.PROFILE,
    ].forEach(LocalStorage.remove);
};

export const apiProductUrl = (link,method = "GET",body,isDownload = false) => {
    const token = LocalStorage.get(CONFIG_LOCAL_STORAGE.ACCESS_TOKEN);
    const url = link.startsWith('http') ? link : `${Config.API_CMS}/api/cms/${link}`;
    return axios({
        method: method,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            // 'Content-Type': 'multipart/form-data'
            Authorization: `Bearer ${token}`
        },
        responseType: isDownload && "blob",
        url: url,
        data: body
    }).then(resp => {
        if (resp.data.code === 401) {
            clearAuthStorage();
            window.location.replace('/login');
        }else if (resp.data.code === 403) {           
            history.push(PATHS.PAGE_403.path)
            history.go();
        }else {
            return resp
        }
    }).catch(e => {
        if(e.response.status === 401){
            clearAuthStorage();
            window.location.replace('/login');
        }else if(e.response.status === 403){
            history.push(PATHS.PAGE_403.path)
            history.go();
        }
        return e.response;
    });
};
